export const REGEX = {
  PRIMITIVES: {
    ONLY_NUMBERS: /^\d+$/
  }
};
